import { render, staticRenderFns } from "./LecturesHallEntityDetails.vue?vue&type=template&id=8e992b1e&scoped=true"
import script from "./LecturesHallEntityDetails.vue?vue&type=script&lang=js"
export * from "./LecturesHallEntityDetails.vue?vue&type=script&lang=js"
import style0 from "./LecturesHallEntityDetails.vue?vue&type=style&index=0&id=8e992b1e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e992b1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e992b1e')) {
      api.createRecord('8e992b1e', component.options)
    } else {
      api.reload('8e992b1e', component.options)
    }
    module.hot.accept("./LecturesHallEntityDetails.vue?vue&type=template&id=8e992b1e&scoped=true", function () {
      api.rerender('8e992b1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LecturesHallEntityDetails.vue"
export default component.exports